import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FeaturesListing from "@components/FeaturesListing/FeaturesListing";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import Meta from "@components/Meta/Meta";
import { remAccents } from "@helpers/utils.js";

const ROOT = process.env.REACT_APP_CMS_STATIC;

function AhorrosProgramadosListado(props) {
  const [matches, setMatches] = useState([]);
  const [ahorrosData, setAhorrosData] = useState([]);
  const [btnSolicite, setBtnSolicite] = useState("");

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);

  const { ahorrosProgramados } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  const defRoute = rutas?.filter((route) => route?.name === "Ahorros Listado");

  const prevRoute = defRoute.map((route) => {
    return {
      url: route.url,
      text: route.h1,
    };
  });

  useEffect(() => {
    ahorrosProgramados &&
      ahorrosProgramados.aCBotonAhorro &&
      ahorrosProgramados.aCBotonAhorro[0]?.imagen &&
      setBtnSolicite(ahorrosProgramados.aCBotonAhorro[0].imagen.urls[0]);
    let promise = new Promise((resolve, reject) => {
      let ahorros = ahorrosProgramados?.aCAhorroProgramado;
      let normalizeAhorros =
        ahorros &&
        ahorros?.map((ahorr) => ({
          ...ahorr,
          nombre: remAccents((ahorr?.titulo).split(" ").join("").toLowerCase()),
          rutaPrevia: prevRoute,
        }));

      resolve(normalizeAhorros);
    });

    promise.then((resultado) => setMatches(resultado));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ahorrosProgramados]);

  useEffect(() => {
    const curSection = rutas && rutas.filter((uri) => uri.name === "Ahorros");
    const rootUri = curSection && curSection[0]?.url;

    let items =
      matches &&
      matches.map((ahorr) => {
        const ahorroUri = ahorr?.rutaPrevia[0]?.url + "/" + ahorr?.idAhorro;

        const botones = [
          {
            ruta: { url: ahorroUri },
            imagen: { urls: [encodeURI("/CSCMS/media/Boton Mas Info.png")] },
          },
        ];
        ahorr?.urlFormularioSoliciteAqui &&
          ahorr?.urlFormularioSoliciteAqui.url &&
          btnSolicite &&
          botones.push({
            ruta: { url: ahorr?.urlFormularioSoliciteAqui.url },
            imagen: { urls: [btnSolicite] },
          });
        return {
          title: ahorr?.titulo,
          image: ROOT + ahorr?.imagen.urls[0],
          url: rootUri.replace("/:id", "/" + ahorr.idAhorro),
          description: ahorr?.resumen?.html,
          buttons: botones,
        };
      });

    setAhorrosData(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matches, btnSolicite]);

  return (
    <div className="pt-5">
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.h1} />
      <h1 className="slogan">{defRoute[0].h1}</h1>
      <FeaturesListing features={ahorrosData} />
    </div>
  );
}

export default AhorrosProgramadosListado;
